export enum TwoFactorTypeEnum {
    authenticator = "authenticator",
    email = "email",
    sms = "sms",
}
